import React from 'react'
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { containerVariants, itemVariants, photoVariants } from "../../variants/variants";

const Section3 = () => {
    const { t } = useTranslation();

    return (
        <motion.div
            initial="hidden"
            whileInView="visible"
            exit="exit"
            variants={containerVariants}

            className="grid grid-cols-10 pb-28">

            <div className='col-start-2 md:col-start-2 col-span-8 md:col-span-4 '>

                <motion.h1 variants={itemVariants} className=" text-65  text-customBlack mb-5 ">
                    {t("socialResponsibility.socialProjects.title")}
                </motion.h1>

                <motion.p variants={itemVariants} className="text-20 font-medium text-customGray5 mb-14 md:w-[80%]">
                    {t("socialResponsibility.socialProjects.text")}
                </motion.p>

            </div>

            <div className='col-start-2 col-span-8 md:col-span-5 md:pl-10  '>
                <motion.img initial="initial"
                    whileInView="whileInView"
                    exit="exit"
                    variants={photoVariants} src='/images/social-responsibility/hand.png' className='h-full w-full object-cover' />
            </div>
        </motion.div>
    )
}

export default Section3
